export default "__VITE_ASSET__CAZ4rILT__"